import { ServiceName, serviceName } from './translation';

export const LANGUAGE_LIST = [
  // { code: 'key', label: 'CodeKey' },
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
  { code: 'th', label: 'ไทย' },
  { code: 'zh', label: '繁體中文' },
];

export const LANGUAGES = {
  // key: 'CodeKey',
  en: 'English',
  ko: '한국어',
  th: 'ไทย',
  zh: '繁體中文',
};

// 로그인할때 필요한 국가 리스트 (API 호출 X) heard by 박창규/@IOS at 08202025
const DISPLAY_LANGUAGE_LIST_FOR_ALL_SERVICES: Record<ServiceName, typeof LANGUAGE_LIST> = {
  bubblechat: LANGUAGE_LIST.filter((lng) => lng.code !== 'en' && lng.code !== 'zh'),
  tingle: LANGUAGE_LIST.filter((lng) => lng.code !== 'en'),
};
export const DISPLAY_LANGUAGE_LIST_BY_SERVICE = DISPLAY_LANGUAGE_LIST_FOR_ALL_SERVICES[serviceName];

export type LanguageCodeListType = keyof typeof LANGUAGES;
